// extracted by mini-css-extract-plugin
export default {"page":"CreateProjectPage_page__kkamI"};